import slugify from "slugify";

export const getProductDetailsUrl = (
	id: string,
	cultivar: string,
	kind?: string | null,
) => {
	const slug = slugify([cultivar, kind ?? ""].join(" "), {
		lower: true,
		strict: true,
		locale: "en",
	});

	return `/product/${slug}/${id}`;
};
